import { useRoute } from "vue-router"
import PageLinkUtils from "../helpers/pageLinkUtils"
import i18n from '@/i18n'
import moment from "moment"

const route = useRoute()
const t = i18n.global.t

export default class Utils {
    static getCurrentSubdomain(): string {
        const permittedSubdomains = ["2Monitori", "Monitori2", "TIKU-Kartat", "TIKUKartat"]
        const splittedSubDomains = window.location.pathname.split("/")

        // Palautetaan subdomainin ensimmäinen alikansio tai tyhjä
        if (splittedSubDomains.length > 1 && splittedSubDomains[1].length > 0) {
            const subdomain = splittedSubDomains[1]

            // Tarkistetaan onko subdomain sallituissa subdomaineissa
            const permitted: boolean = permittedSubdomains.findIndex(element => {
                return element.toLowerCase() === subdomain.toLowerCase()
            }) > -1

            // Jos subdomain on sallittu, käytetään sitä
            if (permitted) {
                return subdomain + "/"
            }
        }

        return ""
    }

    // Muutetaan sivunvaihdon yhteydessä sivuston title kohdesivun mukaan (to).
    // Mikäli kyseessä kielenvaihto tai sivun ensimmäinen lataus,
    // käytetään senhetkisen sivun nimeä valitulla kielellä(pageName)
    static changePageTitle(to?: typeof route, pageName?: string): void {
        const defaultTitle = t("App.Home.Title") !== "App.Home.Title" ? t("App.Home.Title") : document.title
        const pageLinkUtils = new PageLinkUtils()
        // yhdistetään Liikenteen ja Viestinnän puolen linkit samaksi arrayksi
        const pageLinks: Array<any> = pageLinkUtils.getLiikenneLinks().concat(pageLinkUtils.getViestintaLinks())
        let targetPageName = ""
        let pageNameTranslated = ""

        if (to && to.params.pageName) {
            targetPageName = to.params.pageName as string
        }
        else if (pageName) {
            targetPageName = pageName
        }

        if (targetPageName && pageLinks.length > 0) { /* katsotaan sivuston linkkilistasta senhetkistä sivua vastaava kielitermi */
            pageLinks.forEach((link) => {
                if (link.pageName === targetPageName) {
                    pageNameTranslated = t(link.textTerm) ?? ""
                }
            })

            if (pageNameTranslated !== "") {
                document.title = pageNameTranslated + " | " + defaultTitle
            }
        }
        else { /* etusivulla ja mikäli sivun nimeä ei ole saatavilla, näytetään titlessä pelkästään sivuston nimi */
            document.title = defaultTitle
        }
    }

    static getLinkOpensNewTabSpan(): string {
        return "<span class='visually-hidden'>" + t("App.Link.LinkOpensNewTab") + "</span>"
    }

    static isNullOrEmptyString(value: string): boolean {
        return value === null || value === ""
    }

    formatDateShort(value: string | undefined): string {
        if (value === undefined) {
            return ""
        }
        return moment(new Date(String(value))).format("DD.MM.YYYY")
    }

    formatDateTime(value: string | undefined): string {
        if (value === undefined) {
            return ""
        }
        return moment(new Date(String(value))).format("DD.MM.YYYY HH:mm")
    }

    formatPrice(value: number | undefined): string {
        if (value === undefined) {
            return ""
        }
        return (Math.round(value * 100) / 100).toFixed(2).replace(".", ",")
    }
}
